import { CircleAlert } from "lucide-react";

export const ErrorState = ({ message = "An error occurred" }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <CircleAlert className="h-12 w-12 text-red-400" />
      <p className="text-sm font-medium text-red-600">{message}</p>
    </div>
  );
};
